import React from 'react';
import axios from 'axios';
import { subscribe } from 'react-contextual';
import getConfig from 'next/config';
// import './newsletterPanelNew.scss';

const config = getConfig().publicRuntimeConfig;

let newsletterfeatureIcon1 = `${config.cdnUrl}/static/images/newsletter/stories.svg`;
let newsletterfeatureIcon2 = `${config.cdnUrl}/static/images/newsletter/fact-fiction.svg`;
let newsletterfeatureIcon3 = `${config.cdnUrl}/static/images/newsletter/impact.svg`;

class NewsletterPanelNew extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			messageSubmitted: false
		};
	}

	submitNewsletterSubscriptionForm = event => {
		event.preventDefault();

		const name = "";
		const email = document.getElementById('ns-sub-panel-email').value;

		axios({
			method: 'post',
			url: `/api/v1.1/leadGen/create`,
			data: {
				email,
				name,
				source: 'newsletters-homepage',
				_csrf: this.props._csrf
			}
		})
			.then(res => {
				if (res.data.status) {
					const eventData = {
						content_name: 'newsletter-registration-homepage',
						status: true
					};

					if (window.eventDispatcher) {
						window.eventDispatcher.dispatchEvent('Lead', eventData, {
							fbPixel: true
						});
					}

					this.setState({
						messageSubmitted: true,
						message: 'Thank you for signing up!'
					});
				} else {
					this.setState({
						messageSubmitted: true,
						message: 'You have already signed up for our newsletter'
					});
				}
			})
			.catch(err => { });
	};

	render() {
		return (
			<div className="newsletter-container">
				<div className="newsletter-wrapper">
					<div className="newsletter-emailpanel">
						<h2>Add Meaning To Your Inbox
						</h2>
						<div className="newsletter-bar"></div>
					</div>
					<div className="newsletter-panel">
					{!this.state.messageSubmitted ? <p>Sign up today - Stay Informed, be Involved</p> : ''}
						{!this.state.messageSubmitted ? (
							<form onSubmit={e => this.submitNewsletterSubscriptionForm(e)} className="newsletter-form">
								<div className="input-group">
									<input style={{width : '70%', borderRadius: '0', border: '1px solid #ff5050'}}
									required
									type="email"
									name="Email"
									id="ns-sub-panel-email"
									placeholder="Enter Email Address"
									className="form-control newsletter-input" />
									<span className="input-group-btn" >
										<button className="btn btn-default" style={{
											borderRadius: "0",
											backgroundColor: '#ff5050',
											color: "#fff",
										}}>SIGN UP</button>
									</span>
								</div>
							</form>
						) : (
							<div
								className="justify-content-center"
								style={{ alignItems: 'center', maxWidth: '100%' }}
							>
								<p style={{ paddingTop: '1rem', fontSize: '20px' }}>
									{this.state.message}
								</p>
							</div>
						)}
					</div>
					{/* <div className="newsletter-content-wrapper">
						<div className="newsletter">
							<div className="newsletter__icon">
							<img
								className="newsletter-feature-image"
								src={newsletterfeatureIcon1}
								alt=""
								/>
							</div>
							<div className="newsletter__content">
								<h2>Stories from the ground</h2>
								<p>We love telling stories and listening to other peoples's tales. Every week you will get real life stories that Inform,
								give inspiration and bring hope. Stories that put faith back into humanity. Stories that 1.2 lakh people already look forward to every week -  and you wont't want to miss. 
								</p>
							</div>
						</div>
						<div className="newsletter-bar"/>

						<div className="newsletter">
							<div className="newsletter__icon">
							<img
								className="newsletter-feature-image"
								src={newsletterfeatureIcon2}
								alt=""
								/>
							</div>
							<div className="newsletter__content">
								<h2>Fact over fiction</h2>
								<p>We all love to make an impacy and bring positive change to the lives of others. To do that, you need information based on facts, not fiction. That's what we do - and have earned the trust of 1,700+ nonprofits, 3.5 lakh donors and 150+ corporates and philanthropic organisations. Sign up for your weekly dose of facts.</p>
							</div>
						</div>
						<div className="newsletter-bar"/>

						<div className="newsletter">
							<div className="newsletter__icon">
							<img
								className="newsletter-feature-image"
								src={newsletterfeatureIcon3}
								alt=""
								/>
							</div>
							<div className="newsletter__content">
								<h2>Great Impact options</h2>
								<p>Pressing issues require our collectice support. In India, with its rich mix of people and cultures, there are a multitude of causes that need attention. Our weekly email provides information and options to contribute to change. We keep you updtaed about the impact being made -  and give you the choice to make one too.</p>
							</div>
						</div>
					</div> */}
				</div>
			</div>
		);
	}
}
export default subscribe()(NewsletterPanelNew);
